import { Component, ChangeDetectorRef, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Invoice } from '../interfaces/invoice.interface';
import { InvoiceService } from "../services/invoice";
import {Router} from '@angular/router';
import {RouterLink} from '@angular/router';
import { FormsModule } from "@angular/forms";
import { ReactiveFormsModule, FormControl, FormGroup, FormBuilder  } from '@angular/forms';

@Component({
  selector: 'app-invoice',
   imports: [RouterLink, FormsModule, ReactiveFormsModule, DatePipe],
  templateUrl: './invoice.html',
  styleUrl: './invoice.css'
})

export class InvoiceComponent implements OnInit {
  public invoices: Invoice[] = [];
  myForm: FormGroup;
  years: number[] = [];
  myFormControl: FormControl = new FormControl();

  constructor( 
    private invoiceService: InvoiceService, 
    private cdr: ChangeDetectorRef, 
    private router: Router,
    private fb: FormBuilder) 
              {
                this.myForm = this.fb.group({
                datelimit: new FormControl(new Date().getFullYear())
              });
    this.getInvoices(new Date().getFullYear().toString());
  }

  ngOnInit(): void {
    this.populateYears();
    this.myFormControl.setValue(new Date().getFullYear());
    this.myFormControl.valueChanges.subscribe(value => { this.refreshInvoices(value) });
  }

  public async getInvoices(datelimit: string): Promise<void> {
    /* this.customerService.getCustomers().subscribe(
      data => this.customers = data,
      error => console.error('Error fetching data:', error)
    ); */
    try {
    this.invoices = await this.invoiceService.getInvoices(datelimit);
    this.cdr.detectChanges();
    //this.customers = this.customerService.customers;
    } catch (error) {
      console.error('getinvoices',error);
    }
    
  }

   onEdit( invoice: Invoice ): void{
      this.invoiceService.selectedInvoice = invoice;
      this.router.navigateByUrl('editinvoice')
   }

   public async deleteInvoice( invoice: Invoice ): Promise<void> {
      const confirmation = window.confirm(`Are you sure you want to delete ${invoice.invoiceno + " - " + invoice.customername}?`);
      if (!confirmation) {
        this.getInvoices(this.myFormControl.value);
        return;
        }
         try
        {
          await this.invoiceService.delete(invoice.id);
           //this.getInvoices(this.myForm.value.datelimit);
           this.getInvoices(this.myFormControl.value);
           this.cdr.detectChanges();
           this.router.navigateByUrl('invoice')

        } catch (error) {
          console.error('deleteinvoice',error);
        }
   }

    public async refreshInvoices( datelimit: string ): Promise<void> {
         try
        {
          this.invoices = await this.invoiceService.getInvoices(datelimit);
           this.cdr.detectChanges();
           this.router.navigateByUrl('invoice')

        } catch (error) {
          console.error('refresh Invoices',error);
        }
   }  

   populateYears(): void {
    const currentYear = new Date().getFullYear();
    const startYear = 2018; // Or any other starting year
    for (let year = currentYear; year >= startYear; year--) {
      this.years.push(year);
    }
    
  }

}
